import { createSlice } from '@reduxjs/toolkit';

import { Insertion } from '@paragon/contract-library';

import { projectArchived, projectSynchronized } from './layoutModelsSlice';

export type InsertionsState = Insertion[];
const initialState: InsertionsState = [];

const insertionsSlice = createSlice({
  name: 'insertions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(projectArchived, (state, action) => {
      const descendantGuids = new Set(action.payload.descendants);
      return state.filter((insertion) => !descendantGuids.has(insertion.objectGuid));
    });

    builder.addCase(projectSynchronized, (state, action) => {
      const syncPayloads = Object.values(action.payload);

      const expiredParentGuids = new Set(syncPayloads.flatMap((syncPayload) => syncPayload.expiredParentGuids));
      const updatedInsertions = syncPayloads.flatMap((syncPayload) => syncPayload.incomingInsertions);

      // avoid unnecessary updates and re-rendering unless required
      if (!state.some((insertion) => expiredParentGuids.has(insertion.parentGuid)) && updatedInsertions.length === 0) {
        return;
      }

      return state.filter((insertion) => !expiredParentGuids.has(insertion.parentGuid)).concat(updatedInsertions);
    });
  },
});

export const insertions = insertionsSlice.reducer;
